import CartographyPanel from 'components/map/CartographyPanel'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { DANGER_ELEMENT_TYPE } from 'installation/constants/InstallationConstants'
import moment from 'moment'
import InstallationAction from 'installation/actions/InstallationAction'
import PgsseSituationPanel from './PgsseSituationPanel'
import PgsseEntityPanel from './PgsseEntityPanel'
import { Grid } from '@mui/material'
import OtherEntityModal from '../../Dangers/components/OtherEntityModal'
import InstallationDangerModal from '../../Dangers/components/InstallationDangerModal'

const PgsseDangerCarto = ({
    // diagnostic,
}) => {
    const {
        entitiesWithLocation,
    } = useSelector(store => ({
        entitiesWithLocation: store.InstallationReducer.entitiesWithLocation,
    }), shallowEqual)

    const dispatch = useDispatch()

    const [situationDate, setSituationDate] = useState(moment.now())
    const [entityFilter, setEntityFilter] = useState([])
    const [dangSitFilter, setDangSitFilter] = useState([])
    const [open, setOpen] = useState(false)
    const [openDiag, setOpenDiag] = useState(false)

    const getMarkerIcon = danger => {
        if (danger.hasDiagnostic) {
            if (danger.link_dangers.length > 3) {
                return 'pictures/markers/map_installation_red.png'
            } else if (danger.link_dangers.length >= 1) {
                return 'pictures/markers/map_installation_orange.png'
            }
            return 'pictures/markers/map_installation_green.png'
        }
        return 'pictures/markers/map_installation_grey.png'
    }

    // TODO: add blue and replace logic when risk indicator done
    const getColor = (diag, number, type) => {
        if (type === DANGER_ELEMENT_TYPE.INSTALLATION && !diag) {
            return 'grey'
        } else if (number > 3) {
            return 'red'
        } else if (number >= 1) {
            return 'orange'
        }
        return 'green'
    }

    // Only retrive enitites with same campaignId as the diagnosis
    // const campaignEntities = entitiesWithLocation.filter((entity) => diagnostic?.link_campaigns?.idCampaign === entity?.idCampaign)

    // TEMP: to display some value because no links data wet
    const campaignEntities = entitiesWithLocation

    const filteredTypeData = entityFilter.length ? campaignEntities.filter(ewl => entityFilter.includes(ewl.siteType)) : campaignEntities
    const filteredDangSitData = dangSitFilter.length ? campaignEntities.filter(ewl => ewl.link_dangers.some(ld => dangSitFilter.includes(ld.dangerousSituation))) : filteredTypeData
    const data = filteredDangSitData.map(d => ({
        ...d,
        id: d.siteCode,
        typeName: d.siteType === DANGER_ELEMENT_TYPE.INSTALLATION ? 'installation' : 'contributor',
        installationType: d.siteType === DANGER_ELEMENT_TYPE.INSTALLATION ? d.intValue : null,
        markerIcon: getMarkerIcon(d),

        // TODO: change d.link_dangers.length when risk indicator done
        dangerousSituation: d.link_dangers.length,
        color: getColor(d.hasDiagnostic, d.link_dangers.length, d.siteType),
    }))

    useEffect(() => {
        dispatch(InstallationAction.fetchDangersWithLocation(situationDate))
    }, [situationDate])

    const situationPanel = {
        id: 'dangerousSituations',
        icon: 'warning',
        title: i18n.dangerousSituations,
        content:
            <PgsseSituationPanel
                situationDate={situationDate}
                setSituationDate = {setSituationDate}
                entityFilter = {entityFilter}
                setEntityFilter = {setEntityFilter}
                dangSitFilter = {dangSitFilter}
                setDangSitFilter = {setDangSitFilter}
            />,
    }

    const entityPanel = {
        id: 'entities',
        icon: 'view_day',
        title: i18n.entities,
        content:
            <PgsseEntityPanel
                data={data}
            />,
    }

    const panels = [
        situationPanel,
        entityPanel,
    ]

    return (
        <Grid>
            <CartographyPanel
                layers={['STATIONS_POINTS']}
                stationsPoints={data}
                componentType='pgsse'
                panels={panels}
                fullScreenable={false}
                tabsOpenByDefault
                tabsLoadOnClick
                noStationsPanelTitle
            />
            <OtherEntityModal open={open} setOpen={setOpen} readMode />
            <InstallationDangerModal open={openDiag} setOpen={setOpenDiag} />
        </Grid>
    )
}

PgsseDangerCarto.propTypes = {
    diagnostic: PropTypes.shape({
        link_campaigns: PropTypes.shape({
            idCampaign: PropTypes.number,
        }),
    }),
}

export default PgsseDangerCarto